import packageJson from "../package.json";
import axios from "axios";
import { api } from "./components/link";
import { authMode, clearSession, getProfile, getSessionSelector, setProfile } from "./security/http";

const Auth = {
  isAuthenticated: false,

  authenticate() {
    this.isAuthenticated = true;
  },
  async SignOut() {
    this.isAuthenticated = false;
    const selector = getSessionSelector();
    if (authMode() === "jwt" && selector) {
      try {
        await axios.post(`${api()}api/auth/logout`, {}, { headers: { "X-Auth-Session": selector } });
      } catch (_) {}
    } else {
      localStorage.removeItem("token");
    }
    localStorage.removeItem("name");
    localStorage.removeItem("engine");
    clearSession();
  },
  getAuth() {
    if (authMode() === "legacy") return Boolean(localStorage.getItem("token"));
    return Boolean(getSessionSelector() && getProfile()
      && sessionStorage.getItem("ikimina.duplicateTab") !== "true");
  },
  getProfile() {
    return getProfile();
  },
  setProfile(profile) {
    setProfile(profile);
  },

  caching() {
    //console.log("Entering cache validation. Auth");
    let version = localStorage.getItem("version");
    //alert("Package version = " + packageJson.version);

    if (version !== packageJson.version) {
      if ("caches" in window) {
        caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        //alert("Deleted cache");
        //console.log("Deleted cache. Auth writing new date.");
        localStorage.setItem("rcd", new Date());
        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload(true);
      } else {
        //alert("No cache delete");
        //console.log("No cache delete. Auth");
      }

      //localStorage.clear();
      localStorage.setItem("version", packageJson.version);
      //localStorage.setItem("rcd", new Date());
    }
  },

  timecheck(canalert) {
    return true;
  },
  
  handleHttpCodes(error,whereareyou){

    if (error.code === 'ECONNABORTED') {
          console.error('API call timed out');
          alert("Server connection timed out");
        }
        else if (error.response) {
        // Server responded with a status outside 2xx
        switch (error.response.status) {
          case 400:
            alert('Bad Request - check your input.');
            break;
          case 401:
            //alert('Unauthorized - please log in.');
             if(whereareyou !== "Login") {
              
              window.location.href = `${window.location.pathname}#/Login`;
            this.SignOut();
            } else alert('Username or Password is incorrect.');
            
            break;
          case 403:
            if (error.response.data && error.response.data.code === "PASSWORD_CHANGE_REQUIRED") {
              window.location.hash = "#/ChangePassword";
            } else alert('Forbidden - you don’t have access.');
            break;
          case 404:
            alert('Not Found - resource missing.');
            break;
          case 500:
            alert('Server Error - try again later.');
            break;
          default:
            alert(`Unexpected error: ${error.response.status}`);
        }
      }
      else if (error.request) {
          // Request was made but no response received
          alert("Network connection error. Please try again.");
        } else {
          // Something else happened
          console.error('Error setting up request:', error.message);
           if(whereareyou !== "Login") {alert("The request could not be completed.");}
        }


      
  }
  
  ,
  // diff_minutes(dt2, dt1) {
  //   var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  //   diff /= 60;
  //   return Math.abs(Math.round(diff));
  // },
};
export default Auth;
